import axiosInstance from 'api/axiosInstance';
import { URL_CANTRACK_UPDATE_CASE } from 'constants/urls';
import { CaseUpdatePayload } from './types';

/**
 * Updates an existing case.
 * @param caseData - The case fields to update (must include Id)
 * @returns The API response data
 * @throws Re-throws any Axios error after logging
 */
const updateCase = async (caseData: CaseUpdatePayload) => {
  try {
    const { data } = await axiosInstance({
      method: 'POST',
      url: URL_CANTRACK_UPDATE_CASE,
      data: { payload: caseData },
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    });
    return data;
  } catch (error) {
    console.error('[updateCase] Failed:', error);
    throw error;
  }
};

export default updateCase;
